import { render, staticRenderFns } from "./FileDragDropInput.vue?vue&type=template&id=6b8ffe33&scoped=true&"
import script from "./FileDragDropInput.vue?vue&type=script&lang=js&"
export * from "./FileDragDropInput.vue?vue&type=script&lang=js&"
import style0 from "./FileDragDropInput.vue?vue&type=style&index=0&id=6b8ffe33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ffe33",
  null
  
)

export default component.exports